export default {
      id: "common__dry_tanker-usage",
      viewBox: "0 0 24 25",
      url: __webpack_public_path__ + "img/icons.svg#common__dry_tanker",
      toString: function () {
        return this.url;
      }
    }